// PowerSync — `character_sessions` (Ш7, федерация с CharacterHub).
//
// Синкаются ТОЛЬКО метаданные: сообщений в StudyHub нет by design (§3
// федерации). Поэтому офлайн работает список сессий и карточка, а сам чат
// честно просит сеть — он живёт у партнёра.
import { usePowerSyncQuery } from "@/lib/powersync/use-query";

export interface LocalCharacterSession {
	id: string;
	user_id: string;
	external_session_id: string;
	character_external_id: string;
	character_title: string;
	character_avatar_url: string | null;
	scenario: string;
	locale: string;
	/** jsonb → JSON-строка массива UUID. */
	material_ids: string | null;
	subsection_id: string | null;
	message_count: number;
	last_message_at: string | null;
	created_at: string;
	updated_at: string;
}

export function useCharacterSessionsQuery(userId: string | undefined) {
	return usePowerSyncQuery<LocalCharacterSession>(
		`SELECT * FROM character_sessions
		  WHERE user_id = ?
		ORDER BY COALESCE(last_message_at, created_at) DESC`,
		[userId ?? ""],
	);
}

export function useCharacterSessionByIdQuery(sessionId: string | undefined) {
	return usePowerSyncQuery<LocalCharacterSession>("SELECT * FROM character_sessions WHERE id = ?", [
		sessionId ?? "",
	]);
}
